import { api } from '../configs/axiosConfigs';

export const getPropertyAvmResults = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}/avm_results`);
};
